import React, { FC } from 'react';
import styled from 'styled-components';
import { SkeletonBlock, SkeletonFooterBar, SkeletonPageHeader, SkeletonPageShell, SkeletonRow, SkeletonStack } from 'src/components/widgets/skeleton';

const MoqSkeletonShell = styled(SkeletonPageShell).attrs({ $padding: '20px 0 92px' })``;

const MoqSkeletonHeader = styled(SkeletonPageHeader)``;

const MoqSectionSkeleton = styled.div`
    border: 1px solid ${(props) => props.theme.app.borderColor};
    border-radius: 8px;
    background: #ffffff;
    padding: 24px;
    min-width: 0;
`;

const MoqRuleCardSkeleton = styled.div`
    border: 1px solid ${(props) => props.theme.app.borderColor};
    border-radius: 8px;
    background: #ffffff;
    padding: 18px;
    min-width: 0;
`;

const MoqFieldsGridSkeleton = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    min-width: 0;

    @media (max-width: 900px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

const MoqFooterSkeleton = styled(SkeletonFooterBar)``;

export const MoqPageSkeleton: FC = () => (
    <MoqSkeletonShell aria-hidden='true'>
        <MoqSkeletonHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonBlock $width='min(320px, 100%)' $height='26px' />
                <SkeletonBlock $width='min(520px, 100%)' $height='13px' />
            </SkeletonStack>
        </MoqSkeletonHeader>
        <MoqSectionSkeleton>
            <SkeletonStack $gap='18px'>
                <SkeletonBlock $width='90px' $height='20px' />
                {Array.from({ length: 3 }).map((_, index) => (
                    <MoqRuleCardSkeleton key={index}>
                        <SkeletonStack $gap='16px'>
                            <SkeletonRow $justify='space-between' $gap='16px'>
                                <SkeletonBlock $width={index % 2 === 0 ? '180px' : '130px'} $height='18px' />
                                <SkeletonBlock $width='28px' $height='28px' $radius='4px' />
                            </SkeletonRow>
                            {index === 0 && (
                                <MoqFieldsGridSkeleton>
                                    <SkeletonBlock $height='40px' $radius='6px' />
                                    <SkeletonBlock $height='40px' $radius='6px' />
                                    <SkeletonBlock $height='40px' $radius='6px' />
                                </MoqFieldsGridSkeleton>
                            )}
                        </SkeletonStack>
                    </MoqRuleCardSkeleton>
                ))}
            </SkeletonStack>
        </MoqSectionSkeleton>
        <MoqFooterSkeleton>
            <SkeletonBlock $width='90px' $height='36px' $radius='6px' />
        </MoqFooterSkeleton>
    </MoqSkeletonShell>
);

export const MoqRulePageSkeleton: FC = () => <MoqPageSkeleton />;
